<template>
    <v-layout align-top justify-center row wrap>
        <v-flex xs12 sm12 md12 lg5 xl5 class="pa-2 mr-2">
            <h2>Številke registrske tablice</h2>
            <p>
                Z vnosom registrske tablice si zagotovite avtomatsko prepoznavo na prevzemnem mestu in s tem hitrejši prevzem izdelkov.
            </p>
            <empty-space />
            <v-alert
                    :value="errorMsg!=null"
                    type="error"
            >
                {{ errorMsg }}
            </v-alert>
            <v-alert
                    :value="errorMsgSave!=null"
                    type="error"
            >
                {{ errorMsgSave }}
            </v-alert>
            <template v-if="!loadingData && errorMsg == null">
                <licence-plate-number :loading="loading" v-model="settings.licence_plate_1" label="Registrska tablica 1" />
                <licence-plate-number v-model="settings.licence_plate_2" label="Registrska tablica 2" />
                <licence-plate-number v-model="settings.licence_plate_3" label="Registrska tablica 3" />
                <v-btn depressed block color="primary_action" :loading="loading" v-on:click="saveSettings" >SHRANI</v-btn>

                <empty-space height="50px" />
                <span class="title">Privolitve</span>
                <v-checkbox
                        v-model="email_communication"
                        color="primary"
                        required
                >
                    <div slot="label">
                        Prejemanje e-novic za Hitri Nakup
                    </div>
                </v-checkbox>

                <empty-space />
                <span class="title">Odjava iz storitve Hitri Nakup</span>
                <p>Se želite odjaviti iz storitve Hitri nakup?</p>
                <v-btn depressed block :loading="loading" v-on:click="unsubscribe=true" >ODJAVA IZ STORITVE HITRI NAKUP</v-btn>
                <div v-if="unsubscribe">
                    <empty-space />
                    <b>Žal nam je da odhajate. Preden izbrišete račun bi vas radi opozorili:</b>
                    <ul>
                        <li>da se lahko odjavite le od e-novic, če vas obvestila motijo;</li>
                        <li>da bomo z izbrisom računa izbirsali podatke, ki so bili podani na strani Hitri Nakup;</li>
                        <li>da vaše članstvo v Tuš klubu s tem ne bo prekinjeno in še vedno lahko koristite vse ugodnosti.</li>
                    </ul>
                    <v-alert
                            :value="errorMsgUnsubscribe!=null"
                            type="error"
                    >
                        {{ errorMsgUnsubscribe }}
                    </v-alert>
                    <v-layout align-top justify-center row wrap>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-btn depressed block color="primary_action_small" :loading="loading" v-on:click="deleteHNAccount">IZBRIŠI RAČUN</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-btn depressed block :loading="loading" v-on:click="unsubscribe=false" >OBDRŽI RAČUN</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
                <empty-space />
            </template>
            <template v-if="loadingData">
                <div class="loader">
                    <empty-space />
                    <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
                </div>
            </template>
            <v-snackbar
                    v-model="saved"
                    color="success"
                    top
            >
                Številke registrske tablice so bile uspešno shranjene.
                <v-btn
                        text
                        @click="saved = false"
                >
                    Zapri
                </v-btn>
            </v-snackbar>
        </v-flex>
    </v-layout>
</template>

<script>
    import ChangePassword from "./embeded-views/ChangePassword"
    import EmptySpace from "../EmptySpace";
    import {appsService} from "../../services";
    import SplitContent from "../SplitContent";
    import LicencePlateNumber from "../LicencePlateNumberr";

    export default {
        name: "FastOrderTab",
        components: {LicencePlateNumber, EmptySpace, ChangePassword, SplitContent},
        data: vm => ({
            loading: false,
            loadingData: true,
            errorMsg: null,
            errorMsgSave: null,
            errorMsgUnsubscribe: null,
            saved: false,
            settings: {
                licence_plate_1: null,
                licence_plate_2: null,
                licence_plate_3: null,
                communication: {
                    email: 'n'
                }
            },
            unsubscribe: false
        }),
        computed: {
            email_communication: {
                get: function () {
                    return this.settings.communication.email;
                },
                set: function(nvalue){
                    this.settings.communication.email = nvalue;
                }
            }
        },
        watch: {
            email_communication: function (val) {
                this.updateCommunicationChannels();
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData(){
                this.errorMsg = null;
                this.loadingData = true;
                appsService.getAppSettings('HN').then((data) => {
                    this.settings = data;
                }, (err) => {
                    this.errorMsg = err.message;
                }).finally(()=>{
                    this.loadingData = false;
                });
            },
            saveSettings(){
                this.loading = true;
                this.errorMsgSave = null;
                appsService.saveAppSettings('HN', this.settings).then((data) => {
                    this.saved = true;
                },  (err) => {
                    this.errorMsgSave = err.message;
                }).finally(()=>{
                    this.loading = false;
                })
            },
            updateCommunicationChannels(){
                this.loading = true;
                this.errorMsgSave = null;
                appsService.updateCommunicationChannels('HN', this.settings.communication).then((data) => {

                }, (err) => {
                    this.errorMsgSave = err;
                }).finally(() => {
                    this.loading = false;
                });
            },
            deleteHNAccount(){
                this.loading = true;
                this.errorMsgUnsubscribe = null;
                appsService.unsubscribe('HN').then((data) => {
                    this.unsubscribe = false;
                    this.$emit('needReload');
                }, (err) => {
                    this.errorMsgUnsubscribe = err.message;
                }).finally(()=>{
                    this.loading = false;
                });

            }
        }
    }
</script>

<style scoped>
    @import "../../styles/variables.less";

    .loader {
        text-align: center;
    }

</style>